<template>
  <interview-layout>
    <!-- inner wrapper used for centering -->
    <div class="container w-100 d-flex flex-column">
      <!-- Statusmelding direct boven titel, zonder extra ruimte -->
      <div class="px-4 fade-in-up-enter-active animation-slowest max-100 d-flex flex-row justify-content-between align-items-start responsive-intake-end-header">

        <div>
          <!-- Status direct boven titel -->
          <div class="submit-result-indicator" style="margin-bottom: 0; padding-bottom: 0;">
            <div class="submit-message">
              <div class="text-success pulse-opacity-infinite" v-show="busy">
                <i class="bi bi-arrow-down-up me-2"></i>
                Resultaat opslaan...
              </div>
              <div class="text-success" v-show="resultSubmitted">
                <i class="bi bi-check-lg me-2"></i>
                Opgeslagen!
              </div>
              <div class="text-danger" v-show="!busy && !resultSubmitted">
                <i class="bi bi-exclamation-triangle-fill me-2"></i>
                Er is iets fout gegaan!
                <span v-if="uiStore.uuid">
                  U kunt proberen de pagina te
                  <base-button
                    variant="danger"
                    class="ms-2 d-inline-block"
                    icon="bi-arrow-clockwise"
                    icon-position="start"
                    @click="reloadPage">
                    herladen
                  </base-button>
                </span>
              </div>
            </div>
          </div>
          <!-- title and subtitle -->
          <h1 class="mb-0">
            <span class="text-primary">
              {{ titleText }}
            </span>
          </h1>
          <h5 class="px-4 fade-in-up-enter-active animation-slowest delay-200 max-100">
            <span class="subtitle-long">{{ subtitleText }}</span>
            <!-- <base-button
              v-if="(lead.intakeCompletion.UserSituation === 'waiting_isolatieplan' || lead.intakeCompletion.UserSituation === 'quotes_without_plan') && !lead.intakeCompletion.Contact"
              variant="primary"
              class="ms-3"
              icon="bi-chat"
              icon-position="start"
              @click="requestEarlyContact">
              Klik hier om eerder contact te krijgen
            </base-button> -->
          </h5>
        </div>
        <!-- Subsidie informatie -->
          <base-card color="secondary" inner-class="d-flex flex-column" :stretch-inner="true">

          <h2 class="mb-3">Uw subsidiegegevens</h2>
          <info-item icon="bi-percent text-success">
            <span class="fw-500 text-secondary d-block">Vergoedingpercentage:</span>
            <span class="fw-600">
              {{ is100pctSubsidy? '100% van de kosten tot €40.000' : '50% van de kosten, max. €20.000' }}
            </span>
          </info-item>
          <!-- <info-item icon="bi-calendar-week text-success">
            <span class="fw-500 text-secondary d-block">Openstelling postcodegebied:</span>
            <span class="fw-600">
              {{ lead.address.pc_m29_open_from_string || 'Nog niet bekend' }}
            </span>
          </info-item> -->
          <info-item icon="bi-file-earmark-ruled text-success" v-if="isolatiePlanAlwaysRequired">
            <span class="fw-500 text-secondary d-block">Isolatieplan verplicht:</span>
            <span class="fw-600">
              Voor uw woning is een isolatieplan verplicht{{ reasonIsolatieplanAlwaysRequired }}.
            </span>
          </info-item>
        </base-card>
    </div>
    
    <div class="mx-n4 mx-sm-0 px-sm-4 w-sm-100" v-if="showScheduler">
        <base-card
          class="mx-auto mt-5 mb-n5 position-relative appointment-scheduler-bubble fade-in-up-enter-active animation-slowest delay-500"
          inner-class="appointment-scheduler-bubble-inner py-3"
          style="z-index: 3;"
          color="success"
          :opaque="true"
          :bubble-bottom-left="true"
        >
          <img src="@/assets/img/constantijn_blaauwhof.jpg" class="appointment-scheduler-bubble-avatar me-3" alt="Adviseur Constantijn Blaauwhof">
          <div class="d-flex flex-column">
            <h6 class="text-white mb-0 pb-0 fs-1-2em">Plan direct een afspraak met een adviseur!</h6>
            <span class="text-white fs-0-9em opacity-75">Onze vakkundige adviseurs weten alles over verduurzaming binnen Maatregel 29.</span>
          </div>
        </base-card>
        <base-card
          :stretch-inner="true"
          class="fade-in-up-enter-active animation-slowest delay-1300"
          inner-class="overflow-hidden calendly-brand-bg"
        >
          <appointment-scheduler class="mt-4" />
        </base-card>
      </div>
      
      <transition name="fade-in-up">
        <div class="px-4 mt-5 ms-auto" v-show="!busy || resultSubmitted">
          <return-to-portal-button v-if="lead.meta.ReturnUrl" text-align="end" />
        </div>
      </transition>

      <button-row class="mt-4">
        <base-button variant="minimal-secondary" icon="bi-arrow-left" icon-position="start" @click="onPrev">Terug</base-button>
      </button-row>
    </div>
  </interview-layout>
</template>

<script>
  import InterviewLayout from "@/views/layouts/InterviewLayout.vue";
  import BaseCard from '@/components/BaseCard.vue';
  import BaseButton from "@/components/BaseButton.vue";
  import ButtonRow from "@/components/ButtonRow.vue";
  import InfoItem from "@/components/InfoItem.vue";
  import AppointmentScheduler from "@/components/AppointmentScheduler.vue";
  import ReturnToPortalButton from "@/components/ReturnToPortalButton.vue";

  import { useAllStores } from "@/helpers/UseAllStores";
  import { FlowService } from "@/services/FlowService";

  import { StripQuery } from "@/helpers/StripQuery";

  import { LeadDataService } from "@/services/LeadDataService";

  export default {
    components: {
      InterviewLayout,
      BaseCard,
      BaseButton,
      ButtonRow,
      InfoItem,
      AppointmentScheduler,
      ReturnToPortalButton
    },
    setup() {
      return {...useAllStores()};
    },
    data() {
      return {
        expandedIssueSummary: '',
        busy: false,
        resultSubmitted: false,
        showAppointmentScheduler: false
      }
    },
  computed: {
    isTneAanvraagLeadSource() {
      return this.lead.meta.LeadSource.toLowerCase().includes('tneaanvraag');
    },
    titleText() {
    if (this.lead.requiresPersonalFollowUp || this.isTneAanvraagLeadSource) {
      return 'Uw aanmelding is succesvol afgerond';
    }

    const situation = this.lead.intakeCompletion.UserSituation;

    if (situation === 'appointment_isolatieplan') {
      return 'Plan uw afspraak in';
    } else if (situation === 'waiting_isolatieplan') {
      return 'Wacht op uw isolatieplan';
    } else if (situation === 'quotes_without_plan') {
      if (this.lead.address.assigned_partner === 'Bureau voor Verduurzamen') {
        return 'Wij nemen binnenkort contact met u op';
      }
      return 'Plan uw afspraak in';
    } else if (situation === 'waiting_postcode') {
      return 'Postcodefasering nog niet open';
    } else if (situation === 'help_retroactive') {
      return 'Hulp met terugwerkende kracht';
    } else if (situation === 'selecting_own_advisor') {
      return 'Selecteer uw eigen adviseur in het portaal van Nij Begun';
      
    } else {
      return 'Uw aanmelding is succesvol afgerond';
    }
  },
  subtitleText() {
    if (this.lead.requiresPersonalFollowUp) {
      return 'Wij nemen binnen 3 werkdagen contact met u op.';
    }

    if (this.isTneAanvraagLeadSource) {
      return 'Wij nemen binnenkort contact met u op.';
    }

    const situation = this.lead.intakeCompletion.UserSituation;

    if (this.lead.intakeCompletion.Contact === true && (this.lead.intakeCompletion.UserSituation === 'waiting_isolatieplan' || this.lead.intakeCompletion.UserSituation === 'quotes_without_plan')) {
      return 'Wij nemen binnen 3 werkdagen contact met u op';
    }

    if (situation === 'appointment_isolatieplan') {
      return 'Plan hieronder een afspraak in met een bewonersbegeleider.';
    } else if (situation === 'waiting_isolatieplan') {
      return 'Neem contact met ons op zodra u uw isolatieplan heeft ontvangen.';
    } else if (situation === 'help_execution') {
      return "Verstuur het isolatieplan naar klantenservice@bureauverduurzamen.nl";
    } else if (situation === 'quotes_without_plan') {
      if (this.lead.address.assigned_partner === 'Bureau voor Verduurzamen') {
        return '';
      }
      return 'Plan hieronder een afspraak in met een bewonersbegeleider.';
    } else if (situation === 'waiting_postcode') {
      return 'Wij nemen contact met u op zodra uw postcodefasering open is.';
    } else if (situation === 'help_retroactive') {
      return 'Wij nemen contact met u op om uw situatie te bespreken.';
    } else if (situation === 'selecting_own_advisor') { 
      return 'Neem contact met ons op zodra u uw isolatieplan heeft ontvangen.';
    } else {
      return 'Wij nemen binnen 3 werkdagen contact met u op.';
    }
  },
    
      is100pctSubsidy() {
        // Check if the user qualifies for 100% subsidy
        if (this.lead.address.m29_100pct === true || this.lead.financing.income.SM_140pct === true) {
            return true;
        }

        return false;
      },
      isolatiePlanAlwaysRequired() {
        return this.lead.property.IsMonument == true || (this.lead.Isolatieplan_required_bouwjaar);
      },
      reasonIsolatieplanAlwaysRequired() {
        if (this.lead.property.IsMonument) {
          return ', omdat uw woning een monument is';
        } else if (this.lead.property.ConstructionYear < 1965) {
          return ', omdat uw woning is gebouwd vóór 1965';
        } else if (this.lead.property.ConstructionYear > 1991) {
          return ', omdat uw woning is gebouwd na 1991';
        }
        return null;
      },
      showScheduler() {
        if (this.lead.requiresPersonalFollowUp || this.isTneAanvraagLeadSource) {
          return false;
        }

        // Show scheduler for both 'appointment_isolatieplan' and 'quotes_without_plan'
        return this.lead.intakeCompletion.UserSituation === 'appointment_isolatieplan' ||
               (this.lead.intakeCompletion.UserSituation === 'quotes_without_plan' && this.lead.address.assigned_partner !== 'Bureau voor Verduurzamen');
      },
    },
    methods: {
      submitResult() {
        this.busy = true;
      
        LeadDataService.pushRemoteData(this.uiStore.uuid, true)
        .then(() => {
          this.resultSubmitted = true;
        })
        .catch(() => {
          this.resultSubmitted = false;
          console.log('Failed to submit result.');
        })
        .then(() => {
          this.busy = false;
        });
      },

      onPrev() {
        FlowService.pushPrev(this);
      },

      reloadPage() {
        window.location.reload();
      },
      requestEarlyContact() {
        this.lead.intakeCompletion.Contact = true;

        this.submitResult();
      },
    },
    beforeRouteEnter(to) {
      if ('from_result' in to.query) {
        to.query = StripQuery(to.query, 'from_result');
        return to;
      }
    },
  mounted() {
    if (this.lead.intakeCompletion.UserSituation === 'help_retroactive' || 
      this.lead.intakeCompletion.UserSituation === 'general_info') {
      this.lead.intakeCompletion.Contact = true;
    } else {
      this.lead.intakeCompletion.Contact = null;
    }
    this.submitResult();
  },
}
</script>

<style scoped lang="scss">
.issue-summary-button-wrapper {
  font-size: 0.8em;
  text-align: center;
}
.overview-item {
  cursor: pointer;
  transition: opacity 0.2s ease;
  &:hover {
    opacity: 1 !important;
  }
}

.subtitle-long {
  overflow-wrap: anywhere;
  word-break: break-word;
}

.responsive-intake-end-header {
  @media (max-width: 768px) {
    flex-direction: column !important;
    align-items: stretch !important;
    > div,
    > .base-card {
      width: 100%;
      margin-bottom: 1.5rem;
    }
  }
}

// statusmelding direct boven titel, zonder extra ruimte
.submit-result-indicator {
  padding: 0;
  margin-bottom: 0;
  opacity: 0.7;

  .submit-message {
    font-weight: 600;
    font-size: 0.8em;
    text-transform: uppercase;
  }
}
</style>

<style lang="scss">
  .calendly-brand-bg {
    background-color: #fbfcfd !important;
  }
  .appointment-scheduler-bubble {
    &-inner {
      display: flex;
      align-items: center;
      @include std-box-shadow(4, 10, map-get($theme-colors, 'success'), true);
    }
    &-avatar {
      border-radius: 99px;
      height: 50px;
    }
  }
</style>
